<section class="section-gap pb-0">
    <section class="top_footerSection">
        <div class="container">
            <div class="wrapperFooter">
                <div class="col12Wrapper">
                <div class="innerWrapper">
                    <div class="footerLogo-address">
                        <div class="footerLogo">
                            <img src="../../../assets/belairtrip_assets/main/belairtrip.svg" alt="footer logo">
                        </div>
                        <div class="footerAddress">
                            <p class="address"><mat-icon>location_on</mat-icon>&nbsp;{{this.companyList?.company_address}}</p>
                            <div class="contactInfo">
                                <p class="contact"><mat-icon>call</mat-icon>&nbsp;{{this.companyList?.isd_code}}-{{this.companyList?.company_mobile}}</p>
                                <p class="email"><mat-icon>mail</mat-icon>&nbsp;{{this.companyList?.company_email}}</p>
                            </div>
                            <div class="contactInfo">
                                <p class="contact"><mat-icon>language</mat-icon>&nbsp;{{this.companyList?.main_website}}</p>
                                <p class="email"><mat-icon>language</mat-icon>&nbsp;{{this.companyList?.website_url}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="innerWrapper b2bNavInnerWrapper">
                    <!-- B2B nav part -->
                    <div class="wrapperNav">
                        <div class="innerB2BNav">
                            <ul>
                                <li *ngFor="let item of FIRST_B2B_"><a href="u/{{item.path}}" [title]="item.label">{{item.label}}</a></li>
                            </ul>
                        </div>
                        <div class="innerB2BNav">
                            <ul>
                                <li *ngFor="let item of SECOUND_B2B_"><a href="u/{{item.path}}" [title]="item.label">{{item.label}}</a></li>
                            </ul>
                        </div>
                        <div class="innerB2BNav">
                            <ul>
                                <li *ngFor="let item of THIRD_B2B_"><a href="u/{{item.path}}" [title]="item.label">{{item.label}}</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </section>
    <section class="bottom_section">
        <div class="container">
            <div class="wrapperCopyright">
                <div class="innerWrapper copyright">
                    <p>&#x40; 2022 - {{currentYear}} Belair Travel & Cargo Pvt Ltd 
                        <ng-container *ngFor="let item of companies; let i = index">
                            <ng-container *ngIf="item.active === true">
                                {{item?.country_code}}<span *ngIf="i < companies.length - 1">, </span>
                            </ng-container>
                        </ng-container>
                    </p>
                </div>
                <div class="innerWrapper cetifIcon">
                    <ul>
                        <li *ngFor="let item of logoCompy"><img [src]="item.logo" [alt]="" class="img-fluid"></li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</section>
